import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Navigation from '../../home/components/Navigation';
import Footer from '../../home/components/Footer';

interface DestinationCard {
  name: string;
  slug: string;
  region: string;
  image: string;
  tagline: string;
  coordinates: { lat: number; lng: number };
}

const destinations: DestinationCard[] = [
  // Mediterranean
  {
    name: 'Italian Riviera',
    slug: 'italy',
    region: 'Mediterranean',
    image: 'https://images.unsplash.com/photo-1533104816931-20fa691ff6ca?w=800&h=600&fit=crop',
    tagline: 'Cinque Terre charm and Portofino elegance',
    coordinates: { lat: 43.8, lng: 8.5 }
  },
  {
    name: 'French Riviera',
    slug: 'french-riviera',
    region: 'Mediterranean',
    image: 'https://images.unsplash.com/photo-1534258936925-c58bed479fcb?w=800&h=600&fit=crop',
    tagline: "Legendary glamour and sophistication along the Côte d'Azur",
    coordinates: { lat: 43.2, lng: 6.8 }
  },
  {
    name: 'Greece',
    slug: 'greece',
    region: 'Mediterranean',
    image: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=800&h=600&fit=crop',
    tagline: 'Ancient history meets pristine Aegean waters',
    coordinates: { lat: 36.8, lng: 25.5 }
  },
  {
    name: 'Croatia',
    slug: 'croatia',
    region: 'Mediterranean',
    image: 'https://images.unsplash.com/photo-1555990538-1e6c89d63b10?w=800&h=600&fit=crop',
    tagline: 'Over 1,000 islands and historic walled cities',
    coordinates: { lat: 43.0, lng: 15.5 }
  },
  {
    name: 'Italy - Sardinia',
    slug: 'sardinia',
    region: 'Mediterranean',
    image: 'https://images.unsplash.com/photo-1586500036706-41963de24d8b?w=800&h=600&fit=crop',
    tagline: 'Emerald Coast and pristine Mediterranean beaches',
    coordinates: { lat: 40.5, lng: 9.8 }
  },
  {
    name: 'Italy - Sicily',
    slug: 'sicily',
    region: 'Mediterranean',
    image: 'https://images.unsplash.com/photo-1523531294919-4bcd7c65e216?w=800&h=600&fit=crop',
    tagline: 'Ancient culture and volcanic landscapes',
    coordinates: { lat: 37.0, lng: 14.5 }
  },
  {
    name: 'Spain - Balearic Islands',
    slug: 'spain',
    region: 'Mediterranean',
    image: 'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=800&h=600&fit=crop',
    tagline: "Ibiza nightlife and Mallorca's pristine coves",
    coordinates: { lat: 39.2, lng: 2.5 }
  },
  {
    name: 'Turkey',
    slug: 'turkey',
    region: 'Mediterranean',
    image: 'https://images.unsplash.com/photo-1589561454226-796a8aa89b05?w=800&h=600&fit=crop',
    tagline: 'Turquoise Coast and ancient Lycian ruins',
    coordinates: { lat: 36.2, lng: 29.5 }
  },
  {
    name: 'Malta',
    slug: 'malta',
    region: 'Mediterranean',
    image: 'https://images.unsplash.com/photo-1579004196832-6a332e1c537b?w=800&h=600&fit=crop',
    tagline: '7,000 years of history and crystal-clear waters',
    coordinates: { lat: 35.5, lng: 14.2 }
  },
  {
    name: 'Montenegro',
    slug: 'montenegro',
    region: 'Mediterranean',
    image: 'https://images.unsplash.com/photo-1590523741831-ab7e8b8f9c7f?w=800&h=600&fit=crop',
    tagline: 'Dramatic fjords and medieval coastal towns',
    coordinates: { lat: 42.2, lng: 18.5 }
  },

  // Caribbean & Americas
  {
    name: 'Bahamas',
    slug: 'bahamas',
    region: 'Caribbean',
    image: 'https://images.unsplash.com/photo-1548574505-5e239809ee19?w=800&h=600&fit=crop',
    tagline: 'Swimming pigs and pristine turquoise waters',
    coordinates: { lat: 24.5, lng: -77.8 }
  },
  {
    name: 'Mexico - Sea of Cortez',
    slug: 'mexico',
    region: 'Americas',
    image: 'https://images.unsplash.com/photo-1518105779142-d975f22f1b0a?w=800&h=600&fit=crop',
    tagline: 'The Aquarium of the World',
    coordinates: { lat: 26.0, lng: -111.0 }
  },
  {
    name: 'New England',
    slug: 'new-england',
    region: 'Americas',
    image: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800&h=600&fit=crop',
    tagline: 'Historic harbors and classic American charm',
    coordinates: { lat: 41.0, lng: -70.5 }
  },

  // South Pacific
  {
    name: 'Fiji',
    slug: 'fiji',
    region: 'South Pacific',
    image: 'https://images.unsplash.com/photo-1589197331516-4d84b72ebde3?w=800&h=600&fit=crop',
    tagline: 'Soft Coral Capital of the World',
    coordinates: { lat: -17.5, lng: 178.0 }
  },
  {
    name: 'Australia',
    slug: 'australia',
    region: 'South Pacific',
    image: 'https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=800&h=600&fit=crop',
    tagline: 'Great Barrier Reef and pristine coastlines',
    coordinates: { lat: -18.5, lng: 147.5 }
  },
  {
    name: 'New Zealand',
    slug: 'new-zealand',
    region: 'South Pacific',
    image: 'https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=800&h=600&fit=crop',
    tagline: 'Dramatic fjords and pristine islands',
    coordinates: { lat: -36.5, lng: 175.5 }
  },
  {
    name: 'Papua New Guinea',
    slug: 'papua-new-guinea',
    region: 'South Pacific',
    image: 'https://images.unsplash.com/photo-1559128010-7c1ad6e1b6a5?w=800&h=600&fit=crop',
    tagline: 'Remote wilderness and world-class diving',
    coordinates: { lat: -5.0, lng: 152.0 }
  },
  {
    name: 'Vanuatu',
    slug: 'vanuatu',
    region: 'South Pacific',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&h=600&fit=crop',
    tagline: 'Active volcanoes and pristine reefs',
    coordinates: { lat: -16.0, lng: 167.5 }
  },
  {
    name: 'New Caledonia',
    slug: 'new-caledonia',
    region: 'South Pacific',
    image: 'https://images.unsplash.com/photo-1505881502353-a1986add3762?w=800&h=600&fit=crop',
    tagline: 'French elegance meets Pacific paradise',
    coordinates: { lat: -21.5, lng: 165.5 }
  },

  // Asia
  {
    name: 'Myanmar - Mergui Archipelago',
    slug: 'myanmar',
    region: 'Asia',
    image: 'https://images.unsplash.com/photo-1540611025311-01df3cef54b5?w=800&h=600&fit=crop',
    tagline: 'Untouched paradise and sea gypsy culture',
    coordinates: { lat: 11.0, lng: 97.5 }
  },

  // Polar Regions
  {
    name: 'Arctic',
    slug: 'arctic',
    region: 'Polar',
    image: 'https://images.unsplash.com/photo-1517783999520-f068d7431a60?w=800&h=600&fit=crop',
    tagline: 'Polar wilderness and midnight sun',
    coordinates: { lat: 78.0, lng: 16.0 }
  },
  {
    name: 'Alaska',
    slug: 'alaska',
    region: 'Polar',
    image: 'https://images.unsplash.com/photo-1531176175280-33e79b7f0e1c?w=800&h=600&fit=crop',
    tagline: "America's Last Frontier",
    coordinates: { lat: 58.5, lng: -135.0 }
  },
  {
    name: 'Norway',
    slug: 'norway',
    region: 'Polar',
    image: 'https://images.unsplash.com/photo-1520769669658-f07657f5a307?w=800&h=600&fit=crop',
    tagline: 'Dramatic fjords and midnight sun',
    coordinates: { lat: 62.0, lng: 6.0 }
  }
];

// Virtual Tour destinations
const virtualTours = [
  {
    name: 'French Riviera',
    region: 'Mediterranean',
    image: 'https://images.unsplash.com/photo-1590073242678-70ee3fc28e8e?w=1920&h=1080&fit=crop',
    description: 'Experience the legendary glamour of the Côte d\'Azur'
  },
  {
    name: 'Greek Islands',
    region: 'Mediterranean',
    image: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=1920&h=1080&fit=crop',
    description: 'Discover pristine Aegean waters and ancient history'
  },
  {
    name: 'Bahamas',
    region: 'Caribbean',
    image: 'https://images.unsplash.com/photo-1548574505-5e239809ee19?w=1920&h=1080&fit=crop',
    description: 'Explore crystal-clear turquoise waters and pristine beaches'
  },
  {
    name: 'Norwegian Fjords',
    region: 'Polar',
    image: 'https://images.unsplash.com/photo-1513519245088-0e12902e35ca?w=1920&h=1080&fit=crop',
    description: 'Witness dramatic fjords and the midnight sun'
  }
];

const regions = ['All Regions', 'Mediterranean', 'Caribbean', 'South Pacific', 'Asia', 'Polar', 'Americas'];

export default function DestinationsIndex() {
  const navigate = useNavigate();
  const [selectedRegion, setSelectedRegion] = useState<string>('All Regions');
  const [activeVirtualTour, setActiveVirtualTour] = useState<number>(0);
  const [isVirtualTourPlaying, setIsVirtualTourPlaying] = useState<boolean>(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);

  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Auto-rotate virtual tours
  useEffect(() => {
    if (isVirtualTourPlaying) {
      const interval = setInterval(() => {
        setActiveVirtualTour((prev) => (prev + 1) % virtualTours.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isVirtualTourPlaying]);

  const handleDestinationClick = (slug: string) => {
    navigate(`/destinations/${slug}`);
  };

  const scrollToRegion = (region: string) => {
    const element = document.getElementById(`region-${region.toLowerCase().replace(' ', '-')}`);
    if (element) {
      const navHeight = 80;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - navHeight,
        behavior: 'smooth'
      });
    }
  };

  const handleRegionSelect = (region: string) => {
    setSelectedRegion(region);
    setIsDropdownOpen(false);
    if (region !== 'All Regions') {
      scrollToRegion(region);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section className="relative h-[60vh] min-h-[500px]">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/ae099f094c9d982ec8e26a5c0e652f54.jpeg"
            alt="Charter Destinations"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
        </div>

        <div className="relative z-10 h-full flex items-center justify-center px-8">
          <div className="text-center max-w-4xl">
            <div className="w-20 h-px bg-white mx-auto mb-8"></div>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-white mb-6">
              Charter Destinations
            </h1>
            <p className="text-xl md:text-2xl text-white/90 leading-relaxed max-w-3xl mx-auto">
              Discover the world's most sought-after yachting destinations. From the Mediterranean to the Caribbean, SYG Yachts provides expert charter guidance and access to premier yachts worldwide.
            </p>
          </div>
        </div>
      </section>

      {/* Virtual Tours Section */}
      <section className="py-20 px-8 lg:px-16 bg-black">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="w-20 h-px bg-white mx-auto mb-6"></div>
            <h2 className="font-serif text-4xl md:text-5xl text-white mb-4">
              Featured Destination Tours
            </h2>
            <p className="text-lg text-white/70 max-w-2xl mx-auto">
              Experience our top charter destinations through stunning 360° virtual tours before you set sail.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* French Riviera */}
            <div className="group relative h-[400px] overflow-hidden rounded-lg cursor-pointer">
              <img
                src="https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/dd71c9170a9bfde732d93aeed14dd810.jpeg"
                alt="French Riviera 360° Tour"
                className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8">
                <div className="w-16 h-16 rounded-full border-2 border-white flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-360-line text-3xl text-white"></i>
                </div>
                <h3 className="font-serif text-3xl text-white mb-3">French Riviera</h3>
                <p className="text-white/90 mb-6 max-w-md">Experience the legendary glamour of the Côte d'Azur</p>
                <button
                  onClick={() => handleDestinationClick('french-riviera')}
                  className="px-8 py-3 bg-white text-black font-medium rounded-full hover:bg-white/90 transition-colors whitespace-nowrap"
                >
                  EXPLORE DESTINATION
                </button>
              </div>
            </div>

            {/* Greek Islands */}
            <div className="group relative h-[400px] overflow-hidden rounded-lg cursor-pointer">
              <img
                src="https://public.readdy.ai/ai/img_res/f6b5ae8c6fed39659a3212a9f42fcfa8.jpg"
                alt="Greek Islands 360° Tour"
                className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8">
                <div className="w-16 h-16 rounded-full border-2 border-white flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-360-line text-3xl text-white"></i>
                </div>
                <h3 className="font-serif text-3xl text-white mb-3">Greek Islands</h3>
                <p className="text-white/90 mb-6 max-w-md">Sail through ancient history and crystal-clear waters</p>
                <button
                  onClick={() => handleDestinationClick('greece')}
                  className="px-8 py-3 bg-white text-black font-medium rounded-full hover:bg-white/90 transition-colors whitespace-nowrap"
                >
                  EXPLORE DESTINATION
                </button>
              </div>
            </div>

            {/* Bahamas */}
            <div className="group relative h-[400px] overflow-hidden rounded-lg cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=breathtaking%20aerial%20view%20of%20Exuma%20Bahamas%20with%20turquoise%20water%20white%20sand%20beaches%20luxury%20superyacht%20anchored%20in%20crystal%20clear%20Caribbean%20waters%20tropical%20paradise%20sunny%20day%20professional%20travel%20photography&width=800&height=600&seq=bahamas-360&orientation=landscape"
                alt="Bahamas 360° Tour"
                className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8">
                <div className="w-16 h-16 rounded-full border-2 border-white flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-360-line text-3xl text-white"></i>
                </div>
                <h3 className="font-serif text-3xl text-white mb-3">Bahamas</h3>
                <p className="text-white/90 mb-6 max-w-md">Discover pristine beaches and turquoise waters</p>
                <button
                  onClick={() => handleDestinationClick('bahamas')}
                  className="px-8 py-3 bg-white text-black font-medium rounded-full hover:bg-white/90 transition-colors whitespace-nowrap"
                >
                  EXPLORE DESTINATION
                </button>
              </div>
            </div>

            {/* Norwegian Fjords */}
            <div className="group relative h-[400px] overflow-hidden rounded-lg cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=majestic%20Norwegian%20fjords%20with%20dramatic%20mountain%20cliffs%20deep%20blue%20water%20luxury%20yacht%20sailing%20through%20pristine%20Nordic%20landscape%20waterfalls%20cascading%20down%20mountains%20midnight%20sun%20lighting%20professional%20travel%20photography&width=800&height=600&seq=norway-360&orientation=landscape"
                alt="Norwegian Fjords 360° Tour"
                className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8">
                <div className="w-16 h-16 rounded-full border-2 border-white flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-360-line text-3xl text-white"></i>
                </div>
                <h3 className="font-serif text-3xl text-white mb-3">Norwegian Fjords</h3>
                <p className="text-white/90 mb-6 max-w-md">Navigate through dramatic landscapes and pristine nature</p>
                <button
                  onClick={() => handleDestinationClick('norway')}
                  className="px-8 py-3 bg-white text-black font-medium rounded-full hover:bg-white/90 transition-colors whitespace-nowrap"
                >
                  EXPLORE DESTINATION
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Region Selection Section */}
      <section className="py-20 px-8 lg:px-16 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="w-20 h-px bg-black mx-auto mb-6"></div>
            <h2 className="font-serif text-4xl md:text-5xl text-black mb-4">
              Explore Our Charter Regions
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Select a region below to discover the perfect charter destination for your next voyage.
            </p>
          </div>

          {/* Region Dropdown */}
          <div className="max-w-md mx-auto mb-12">
            <div className="relative">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="w-full px-6 py-4 bg-white border border-gray-200 rounded-lg shadow-sm flex items-center justify-between cursor-pointer hover:border-gray-300 transition-colors"
              >
                <span className="text-lg text-gray-800">{selectedRegion}</span>
                <i className={`ri-arrow-down-s-line text-xl text-gray-500 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isDropdownOpen && (
                <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-20 overflow-hidden">
                  {regions.map((region) => (
                    <button
                      key={region}
                      onClick={() => handleRegionSelect(region)}
                      className={`w-full px-6 py-4 text-left hover:bg-gray-50 transition-colors cursor-pointer flex items-center justify-between ${
                        selectedRegion === region ? 'bg-gray-50' : ''
                      }`}
                    >
                      <span className="text-gray-800">{region}</span>
                      {region !== 'All Regions' && (
                        <span className="text-sm text-gray-500">
                          {destinations.filter(d => d.region === region).length} destinations
                        </span>
                      )}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Quick Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center p-6 bg-white rounded-xl shadow-sm">
              <div className="text-4xl font-serif text-black mb-2">{destinations.length}</div>
              <div className="text-sm text-gray-600">Charter Destinations</div>
            </div>
            <div className="text-center p-6 bg-white rounded-xl shadow-sm">
              <div className="text-4xl font-serif text-black mb-2">6</div>
              <div className="text-sm text-gray-600">Global Regions</div>
            </div>
            <div className="text-center p-6 bg-white rounded-xl shadow-sm">
              <div className="text-4xl font-serif text-black mb-2">365</div>
              <div className="text-sm text-gray-600">Days of Sunshine</div>
            </div>
            <div className="text-center p-6 bg-white rounded-xl shadow-sm">
              <div className="text-4xl font-serif text-black mb-2">∞</div>
              <div className="text-sm text-gray-600">Unforgettable Moments</div>
            </div>
          </div>
        </div>
      </section>

      {/* Destinations Grid */}
      <section className="py-24 px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          {regions
            .filter(r => r !== 'All Regions')
            .map((region) => {
              const regionDestinations = destinations.filter(d => d.region === region);
              if (regionDestinations.length === 0) return null;

              return (
                <div key={region} id={`region-${region.toLowerCase().replace(' ', '-')}`} className="mb-20">
                  <div className="mb-12">
                    <div className="w-20 h-px bg-black mb-6"></div>
                    <h2 className="font-serif text-4xl md:text-5xl text-black">{region}</h2>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {regionDestinations.map((destination) => (
                      <div
                        key={destination.slug}
                        onClick={() => handleDestinationClick(destination.slug)}
                        className="group cursor-pointer"
                      >
                        <div className="relative w-full h-[400px] overflow-hidden mb-6 rounded-lg shadow-lg">
                          <img
                            src={destination.image}
                            alt={destination.name}
                            className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                          <div className="absolute bottom-0 left-0 right-0 p-6">
                            <h3 className="font-serif text-3xl text-white mb-2">{destination.name}</h3>
                            <p className="text-white/90 text-sm mb-4">{destination.tagline}</p>
                          </div>
                        </div>
                        <button className="w-full px-8 py-4 bg-black text-white text-sm tracking-widest hover:bg-gray-800 transition-all duration-300 whitespace-nowrap cursor-pointer">
                          EXPLORE DESTINATION
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-8 lg:px-16 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-20 h-px bg-black mx-auto mb-8"></div>
          <h2 className="font-serif text-4xl md:text-5xl text-black mb-8">Ready to Plan Your Charter?</h2>
          <p className="text-lg text-gray-700 mb-12 leading-relaxed">
            Our charter specialists are ready to help you find the perfect yacht and create an unforgettable itinerary.
          </p>
          <Link
            to="/yacht-charter"
            className="inline-block px-12 py-5 bg-black text-white text-sm tracking-widest hover:bg-gray-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            VIEW AVAILABLE YACHTS
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
